$(document).on('click', '.collapser', function () {
	$(this).next().toggleClass('show');
	$(this).toggleClass('collapsed');
	//$(this).next().css('max-height', '200px');
});